import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './DataPage.css';

import { API_URL } from '../config';

function Laboratorios() {
  const [laboratorios, setLaboratorios] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLaboratorios();
  }, []);

  const fetchLaboratorios = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/laboratorios`);
      setLaboratorios(response.data || []);
    } catch (err) {
      console.error('Erro ao buscar laboratórios:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatarValor = (value) => {
    if (value === null || value === undefined || value === '') return '-';
    if (typeof value === 'boolean') return value ? 'Sim' : 'Não';
    if (value === 'T' || value === 't') return 'Sim';
    if (value === 'F' || value === 'f') return 'Não';
    return String(value);
  };

  if (loading) {
    return <div className="loading">Carregando laboratórios...</div>;
  }

  const styles = {
    pageHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '24px',
      flexWrap: 'wrap',
      gap: '12px',
    },
    pageIcon: {
      fontSize: '1.5rem',
      lineHeight: 1,
    },
    pageTitle: {
      fontSize: '1.5rem',
      fontWeight: '700',
      color: '#1a1a2e',
      margin: '0 0 2px 0',
    },
    pageSubtitle: {
      fontSize: '0.85rem',
      color: '#666',
      margin: 0,
    },
  };

  return (
    <div className="data-page">
      <div style={styles.pageHeader}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={styles.pageIcon}>🏥</span>
          <div>
            <h1 style={styles.pageTitle}>Laboratórios</h1>
            <p style={styles.pageSubtitle}>Total: {laboratorios.length} laboratórios cadastrados</p>
          </div>
        </div>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Razão Social</th>
              <th>Nome Fantasia</th>
              <th>CNPJ</th>
              <th>Cidade</th>
              <th>Estado</th>
              <th>Telefone</th>
              <th>Email</th>
              <th>Responsável 1</th>
              <th>CRF 1</th>
            </tr>
          </thead>
          <tbody>
            {laboratorios.map((lab) => (
              <tr key={lab.ID}>
                <td><strong>{lab.ID}</strong></td>
                <td><strong>{lab.RAZAOSOCIAL}</strong></td>
                <td>{formatarValor(lab.NOMEFANTASIA)}</td>
                <td>{formatarValor(lab.CGC)}</td>
                <td>{formatarValor(lab.CIDADE)}</td>
                <td>{formatarValor(lab.ESTADO)}</td>
                <td>{formatarValor(lab.TELEFONE)}</td>
                <td>{formatarValor(lab.EMAIL)}</td>
                <td>{formatarValor(lab.RESPONSAVEL1)}</td>
                <td>{formatarValor(lab.CRF1)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {laboratorios.length === 0 && !loading && (
        <div className="no-data">
          <p>Nenhum laboratório encontrado.</p>
        </div>
      )}
    </div>
  );
}

export default Laboratorios;
